import { Dialog } from '@cmsgov/ds-medicare-gov';
import { useEffect } from 'react';
import { helpDrawerClosed, helpDrawerOpened } from '../analytics';
import '../css/dialog.css';
import translate from '../functions/translate';
import medicareCard from '../images/medicare-card-new.png';
import X from '../images/x.svg';
import Button from './button';
import Div from './div';
import H2 from './h2';
import TranslatedSpan from './TranslatedSpan';

interface MedicareNumberDialogProps {
    isOpen: boolean
    onExit: () => void
}

const MedicareNumberDialog = (props: MedicareNumberDialogProps) => {

    const headerText = translate('where_to_find_mbi');
    useEffect(() => {
        if (props.isOpen) {
            helpDrawerOpened(headerText, headerText);
        }
    }, [props.isOpen, headerText]);

    const exit = () => {
        props.onExit();
        helpDrawerClosed(headerText);
    }
    if (!props.isOpen)
        return null;
    return <>
        <Dialog
            className={'drawer-dialog'}
            getApplicationNode={() => document.getElementById('App')}
            headerClassName={'drawer-dialog-header'}
            onExit={props.onExit}
            underlayClickExits={true}
        >
            <H2>
                <div style={{
                    cursor: 'pointer',
                    float: 'right',
                }}>
                    <Button
                        aria-label={translate('close')}
                        variation={'ghost'}
                        onClick={exit}
                    >
                        <img
                            alt={translate('close')}
                            src={X}
                            style={{
                                position: 'relative',
                                bottom: 15,
                                left: 15,
                            }}
                        />
                    </Button>
                </div>
                <div>
                    {headerText}
                </div>
            </H2>
            <Div paddingyMD={1} paddingyXL={2}>
                <TranslatedSpan english={'check_medicare_card'}/>
            </Div>
            <Div paddingyMD={1} paddingyXL={2}>
                <TranslatedSpan english={`if_new_to_medicare`}/>{` `}
                <a href={'https://www.ssa.gov/myaccount/'}>
                    <TranslatedSpan english={'logging_social_secuirty_account'}/>
                </a>.
            </Div>
            <Div paddingyMD={1} paddingyXL={2}>
                <TranslatedSpan english={'if_need_help_contact_us'}/>
            </Div>
            <Div
                paddingyMD={1} paddingyXL={2}
                style={{textAlign: 'center'}}
            >
                <img
                    alt={translate('medicare_card_example')}
                    src={medicareCard}
                    style={{
                        maxWidth: 400,
                        width: '100%',
                    }}
                />
            </Div>
        </Dialog>
    </>
}

export default MedicareNumberDialog;
